import { combine, persist } from 'zustand/middleware';
import { shallow } from 'zustand/shallow';
import { createWithEqualityFn } from 'zustand/traditional';

export const saveKey = 'search';
export const maxLen = 50;
// store
export const useSearchStore = createWithEqualityFn(
  persist(
    combine(
      {
        searchList: [] as string[],
      },
      (set, get) => {
        return {
          setSearchList: (searchList: string[]) => set({ searchList }),
          addSearch: (search: string) => {
            const history = get().searchList;
            if (history.length >= maxLen) {
              history.shift();
            }
            set({ searchList: [...history, search] });
          },
          removeSearch: (search: string) => set(state => ({ searchList: state.searchList.filter(item => item !== search) })),
          clearSearch: () => set({ searchList: [] }),
        };
      }
    ),
    { name: saveKey }
  ),
  shallow
);
export default useSearchStore;
